import { List, Datagrid, TextField,
         Edit, SimpleForm, Create, FunctionField,
         NumberField, EditButton, DeleteButton,
         TextInput,
         NumberInput} from 'react-admin';

export const WebsiteList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="threat_model_path" />
    </Datagrid>
  </List>
);

export const AssignmentList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="account_id" />
      <TextField source="website_id" />
      <NumberField source="order_index" />
      <NumberField source="time_limit_minutes" />
      <NumberField source="time_limit_document_minutes" />
      <FunctionField source="assigned_at" render={
          record => {
            return new Date(record.assigned_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <FunctionField source="server_started_at" render={
          record => {
            if (!record.server_started_at) return "";
            return new Date(record.server_started_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <FunctionField source="server_stopped_at" render={
          record => {
            if (!record.server_stopped_at) return "";
            return new Date(record.server_stopped_at).toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
      } />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const AssignmentEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="account_id" />
      <TextInput source="website_id" />
      <NumberInput source="order_index" />
      <NumberInput source="time_limit_minutes" />
  <NumberInput source="time_limit_document_minutes" />
    </SimpleForm>
  </Edit>
);

export const AssignmentCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="account_id" />
      <TextInput source="website_id" />
      <NumberInput source="order_index" />
      <NumberInput source="time_limit_minutes" />
    </SimpleForm>
  </Create>
);
